export const SET_OPTION_LIST = 'SET_OPTION_LIST';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const SET_SEARCH_PARAM = 'SET_SEARCH_PARAM';

export default {
	SET_OPTION_LIST,
	DEFAULT_ASSIGN,
	SET_SEARCH_PARAM
};
